import { shiftListEmployeeComponent } from './shift.list.employee.component';
import { shiftListItemComponent } from './shift.list.item.component';
import { CalendarService } from '../../services/calendar.service';
import { shiftListComponent } from './shift.list.component';
import { shiftCalendarComponent } from './shift.calendar.component';
import { shiftItemComponent } from './shift.item.component';
import { shiftComponent } from './shift.component';
import {
    checkAvailabilityState,
    shiftCalendarState,
    shiftItemState,
    shiftListEmployeeState,
    shiftListItemState,
    shiftListState,
    shiftState,
} from './shift.states';

import { loadNg1Module, ngmodule } from "../../bootstrap/ngmodule";
import { employeeSummaryComponent } from "./employeeSummary.component";
import { checkAvailabilityModalComponent } from "./checkAvailabilityModal.component";
import { employeePickerComponent } from "./employeePicker.component";
import { shiftListSubscriptionsModalState } from './shift.states';
import { subscriptionsModalComponent } from './subscriptionsModal.component';

const applicationsAppModule: aboTheme.INgModule = {
  components: {shiftComponent, shiftItemComponent, shiftCalendarComponent, shiftListComponent, checkAvailabilityModalComponent, employeePickerComponent, employeeSummaryComponent, shiftListItemComponent, shiftListEmployeeComponent, subscriptionsModalComponent },
  states: [shiftState, shiftItemState, shiftCalendarState, shiftListState, shiftListItemState, checkAvailabilityState, 
    shiftListEmployeeState, shiftListSubscriptionsModalState],
  services: {CalendarService}
};

loadNg1Module(ngmodule, applicationsAppModule);


// WEBPACK FOOTER //
// ./src/app/modules/shifts/index.ts